import React, {useEffect, useState} from "react";
import QRCode from "react-qr-code";
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import { useUser } from './UserContext';
import './css/PaymentPage.css';
import {createTransaction, listPaymentMethods, prepareTransaction} from './api';
import {Button} from "primereact/button";

import {FloatLabel} from "primereact/floatlabel";
import {ProgressSpinner} from "primereact/progressspinner";
import {Message} from "primereact/message";
import {SelectButton, SelectButtonChangeEvent} from "primereact/selectbutton";
import IframeWithSpinner from "./iframeWithSpinner";
import {InputText} from "primereact/inputtext";


const PaymentPage: React.FC = () => {

    const {userIP, userCountry, userLoading} = useUser();

    // Para evitar ejecuciones múltiples de generateTransaction con redeemPin
    const [hasGenerated, setHasGenerated] = useState(false);

    const [iframeUrl, setIframeUrl] = useState('');
    const [cryptoData, setcryptoData] = useState<any>(null);

    const [disableButton, setdisableButton] = useState<boolean>(false);
    const [apiErrorMessage, setapiErrorMessage] = useState<string>('');
    const [placeOrderText, setPlaceOrderText] = useState<string>('Place Order');

    const [isApiError, setisApiError] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [transactionData, setTransactionData] = useState<any>(null);
    const {paramProductID, paramJWT, paramCoupon} = useParams<{
        paramProductID: string;
        paramJWT: string;
        paramCoupon?: string
    }>();
    const [couponValue, setCouponValue] = useState('');
    const [invalidCoupon, setInvalidCoupon] = useState<boolean>(false);

    const [gatewayOptions, setGatewayOptions] = useState([]); // Estado para las opciones de gateway
    const [selectedGateway, setSelectedGateway] = useState<object>();

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // Leer el JWT desde la query string si existe
    const queryJWT = searchParams.get('jwt');
    const customPayout = searchParams.get('customPayout') === 'true';
    const customGW: any = searchParams.get('customGW') || false;
    const customEmail: any = searchParams.get('customEmail') || false;
    const redeemPin: any = searchParams.get('redeemPin') || false;


    const [showPaymentMethods, setShowPaymentMethods] = useState(false);
    const [PaymentMethods, setPaymentMethods] = useState<any>([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>(null);

    const [hasLocalCurrency, setHasLocalCurrency] = useState<boolean>(false);
    const [localCurrencyAmount, setLocalCurrencyAmount] = useState<number>(1); // e.g. 12.75
    const [localCurrencyCode, setLocalCurrencyCode] = useState<string>('USD');     // e.g. "ARS"

    const [hideSelector, setHideSelector] = useState<boolean>(false);


    const extractTenantFromJWT = (jwt: string | null): string | null => {
        try {
            if (!jwt) return null;

            const payloadBase64 = jwt.split('.')[1];
            const payloadJson = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
            const payload = JSON.parse(payloadJson);

            return payload.tenant || null;
        } catch (e) {
            console.error("Failed to parse JWT:", e);
            return null;
        }
    };

    const tenant = extractTenantFromJWT(queryJWT);



    const selectPayment = (payment: any) => {
        if (!payment || payment.id_payment_method === selectedPaymentMethod) return;

        setSelectedPaymentMethod(payment.id_payment_method);

        if (payment.local_currency === 1) {
            setHasLocalCurrency(true);
            setLocalCurrencyAmount(payment.value);
            setLocalCurrencyCode(payment.code);
        } else {
            resetLocalCurrencys();
        }
    };

    const resetLocalCurrencys = () => {
        setHasLocalCurrency(false);
        setLocalCurrencyAmount(1);
        setLocalCurrencyCode('USD');
    }


    const selectgateway = (gateway: React.SetStateAction<object | undefined>) => {
        // Si es el mismo gateway seleccionado actualmente, o si gateway es null/undefined, no hacemos nada
        if (!gateway || gateway === selectedGateway) return;
        // Consultamos los Payment methods y actualizamos
        paymentMethods(gateway);
        setSelectedGateway(gateway);
    };


    useEffect(() => {
        const gatewayName = selectedGateway ? (selectedGateway as any).gateway_name || '' : '';
        const methodName = selectedPaymentMethod
            ? (PaymentMethods.find((pm: any) => pm.id_payment_method === selectedPaymentMethod)?.name || '')
            : '';

        if (gatewayName || methodName) {
            setPlaceOrderText(`Place Order ${gatewayName ? ' (' + gatewayName : ''}${methodName ? ' - ' + methodName : ''}${gatewayName || methodName ? ')' : ''}`);
        } else {
            setPlaceOrderText('Place Order');
        }
    }, [selectedGateway, selectedPaymentMethod, PaymentMethods]);


    useEffect(() => {
        // Si `paramJWT` no existe pero `queryJWT` sí, redirigir a la URL con parámetros
        if (!paramJWT && queryJWT) {
            navigate(`/pay/${paramProductID}/${queryJWT}${paramCoupon ? `/${paramCoupon}` : ''}`, { replace: true });
        }
    }, [paramJWT, queryJWT, paramProductID, paramCoupon, navigate]);

    useEffect(() => {
        if (!userLoading && paramProductID && paramJWT && userIP && userCountry) {
            if (paramCoupon) {
                setCouponValue(paramCoupon);
            }
            callPrepareTransaction(paramProductID, paramJWT, userIP, userCountry, paramCoupon, customPayout, customGW, redeemPin, customEmail, tenant);
        }
    }, [ userLoading, paramProductID, paramJWT, paramCoupon, userIP, userCountry]);





    /*
    interface Payment {
        gateway_name: string;
        icon?: string;  // Propiedad opcional
        // Añadir otras propiedades relevantes aquí
    }*/

    useEffect(() => {
        if (
            redeemPin &&
            !isLoading &&
            transactionData &&
            selectedPaymentMethod &&
            selectedGateway &&
            !hasGenerated
        ) {
            setHasGenerated(true);
            //generateTransaction();
        }
    }, [redeemPin, isLoading, transactionData, selectedPaymentMethod, selectedGateway, hasGenerated]);


    interface OptionType {
        logo: string;
        label: string;
        id_gateway: bigint;
        value: bigint,
        local_currency: boolean,
        currency_code: string,
        dolar_value: string,
    }

    const hideSelectors = () => {
        console.log("Hide selectors");
        setHideSelector(true);
    }

    // Highlight selected gateway with border
    const GatewaySelectTemplate = (option: OptionType) => {
        const logoPath = `/assets/img/logos/gateways/${option.id_gateway}.jpg`;
        const isSelected = selectedGateway && (selectedGateway as any).id_gateway === option.id_gateway;
        const borderStyle = isSelected ? '' : '2px solid transparent';

        return (
            <div style={{ border: borderStyle}}>
                <img src={logoPath} alt={option.label} style={{ height: '50px' }} />
            </div>
        );
    };

const PaymentSelectTemplate = (option: any) => {
    const isSelected = selectedPaymentMethod === option.value.id_payment_method;
    const logoPath = `/assets/img/logos/payment_methods/${option.value.id_payment_method}.png`;
    const borderStyle = isSelected ? '' : '2px solid transparent';

    return (
        <div style={{ border: borderStyle}}>
            <img src={logoPath} alt={option.label} style={{ height: '50px' }} />
        </div>
    );
};


    const handleApplyClick = () => {
        applyCoupon(couponValue);
    };

    const callPrepareTransaction = async (
        product_id: string | undefined,
        jwt: string | undefined,
        userIP: string,
        userCountry: string,
        coupon?: string | undefined,
        customPayout?: any,
        customGW?: any,
        redeemPin?: any,
        customEmail?: string,
        tenant?: any
    ) => {
        setIsLoading(true); // Asegúrate de que el estado de carga sea verdadero al inicio de la llamada
        try {
            const data = await prepareTransaction({
                id_product: product_id,
                jwt: jwt,
                userIP: userIP,
                userCountry: userCountry,
                coupon: coupon,
                customPayout: customPayout,
                customGW: customGW,
                redeemPin: redeemPin,
                customEmail: customEmail,
                tenant: tenant
            });

            console.log(data);
            setTransactionData(data);
            setIsLoading(false);

            // Validamos el cupon y aplicamos el mensaje de error
            if (data.product.promo === false && couponValue.length > 0) {
                setInvalidCoupon(true);
            } else {
                setInvalidCoupon(false);
            }

            // Verificar si transactionData.payment tiene datos
            if (!data.payment || data.payment.length === 0) {
                setisApiError(true);
                setdisableButton(true);
                setapiErrorMessage("Payment gateway is not available for your country.");
            } else {
                // Tenemos Payments, actualizar opciones de gateway
                const options = data.payment.map((payment: { gateway_name: any; id_gateway: any; }, index: any) => ({
                    label: payment.gateway_name,
                    value: payment,
                    id_gateway: payment.id_gateway
                }));
                setGatewayOptions(options);
                // Selección automática de gateway y métodos si redeemPin está activo
                if (redeemPin && data.payment.length > 0) {
                    const firstGateway = data.payment[0];
                    setSelectedGateway(firstGateway);
                    paymentMethods(firstGateway);
                    hideSelectors();


                }
            }
        } catch (error) {
            setIsLoading(false);
            setisApiError(true);
            setdisableButton(true);
        }
    };

    const applyCoupon = (newCoupon: string) => {
        setIsLoading(true);
        callPrepareTransaction(paramProductID, paramJWT, userIP, userCountry, newCoupon, customPayout, customGW, redeemPin, customEmail, tenant);
    };

    const generateTransaction = async() => {

        if (PaymentMethods.length > 0 && !selectedPaymentMethod) {
            setisApiError(true);
            setapiErrorMessage("Please select a payment method.");
            return;
        }

        setIsLoading(true);
        const data = {
            signature: transactionData?.signature,
            gateway: selectedGateway ?? (transactionData.payment?.[0] ?? false),
            id_payment_method: selectedPaymentMethod
        };
        const createdTransaction = await createTransaction({
            data: data,
            jwt: paramJWT,
            userIP: userIP,
            userCountry: userCountry,
            tenant: tenant
        });

        if(createdTransaction?.status){
            if(createdTransaction.iframe){
                setIframeUrl(createdTransaction.pay_link);
            } else if(createdTransaction.crypto){
                setcryptoData(createdTransaction);
            } else {
                window.location.href = createdTransaction.pay_link;
            }

            setIsLoading(false)
        } else {
            setIsLoading(false)
            setisApiError(true);
            setapiErrorMessage(createdTransaction.message);
        }
    };


    const paymentMethods = async(gateway: any) => {
        setSelectedPaymentMethod(3);
        resetLocalCurrencys();
        //setIsLoading(true);
        const data = {
            gateway: gateway
        };
        const paymentMethodsArr = await listPaymentMethods({
            data: data,
            jwt: paramJWT,
            userIP: userIP,
            userCountry: userCountry
        });

        if (paymentMethodsArr) {
            setShowPaymentMethods(true);
            setPaymentMethods(paymentMethodsArr);
            setIsLoading(false)
            // Selección automática del método con id_payment_method === 3, o el primero si no se encuentra
            if (redeemPin && paymentMethodsArr.length > 0) {
                const defaultMethod = paymentMethodsArr.find((m: any) => Number(m.id_payment_method) === 3) || paymentMethodsArr[0];
                setSelectedPaymentMethod(defaultMethod.id_payment_method);
                if (defaultMethod.local_currency === 1) {
                    setHasLocalCurrency(true);
                    setLocalCurrencyAmount(defaultMethod.value);
                    setLocalCurrencyCode(defaultMethod.code);
                }
                // generateTransaction(); // <--- ELIMINADO SEGÚN INSTRUCCIÓN
            }
        } else {
            setPaymentMethods([]);
            setShowPaymentMethods(false);
            setIsLoading(false)
        }
    };

    return (
    <div className="flex align-items-center justify-content-center">
        <div className="surface-card p-4 shadow-2 border-round w-full lg:w-6">
            {isLoading || userLoading ? (
                <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" className="flex" />
            ) : (
                <>
                    {iframeUrl  ? (
                        <>
                            <div className="flex align-items-center mb-5">
                                <img src={transactionData.product.icon} alt="hyper" className="product_ico"/>
                                <div className="text-900 text-3xl font-medium ml-3">{transactionData.product.name_with_discount}</div>
                            </div>

                            <div id="payment-container" style={{width: '100%', height: '500px', marginTop: '-100px'}}>
                                <IframeWithSpinner src={iframeUrl} />
                            </div>
                        </>
                    ) : cryptoData && cryptoData.crypto ? (
                        <>
                            <div className="flex align-items-center mb-5">
                                <img src={transactionData.product.icon} alt="crypto" className="product_ico"/>
                                <div className="text-900 text-3xl font-medium ml-3">{transactionData.product.name_with_discount}</div>
                            </div>

                            <div className="text-center">
                                <p className="text-lg font-medium">Escanea este QR para pagar con cualquier billetera:</p>
                                {/* Generamos el QR Code con la dirección y monto */}
                                {cryptoData.qr_code && (
                                    <QRCode
                                        value={cryptoData.qr_code}
                                        size={250}
                                        className="mx-auto mt-3"
                                    />
                                )}
                                <p className="mt-4 text-sm text-gray-500">O copia esta dirección:</p>
                                <input
                                    type="text"
                                    value={cryptoData.wallet_address}
                                    readOnly
                                    className="border p-2 w-3/4 text-center"
                                />
                                <button
                                    className="mt-3 px-4 py-2 bg-blue-600 text-white rounded"
                                    onClick={() => {
                                        navigator.clipboard.writeText(cryptoData.wallet_address);
                                        alert("Dirección copiada al portapapeles!");
                                    }}
                                >
                                    Copiar Dirección
                                </button>

                                {/* Botón para MetaMask */}
                                <button
                                    onClick={() => {
                                        if (cryptoData?.pay_link) {
                                            window.open(cryptoData.pay_link, "_blank");
                                        } else {
                                            alert("No se pudo generar el enlace de pago.");
                                        }
                                    }}
                                    className="mt-3 px-4 py-2 bg-green-600 text-white rounded"
                                >
                                    Pagar con MetaMask
                                </button>

                            </div>
                        </>
                    ) : (
                        <div>
                            <div className="text-center mb-5">
                                <img src={transactionData.product.icon} alt="hyper" className="mb-3 product_ico"/>
                                <div
                                    className="text-900 text-3xl font-medium mb-3">{transactionData.product.name_with_discount}</div>
                            </div>

                            <FloatLabel>
                                <div className="p-inputgroup flex-1">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-receipt"></i>
                                </span>
                                    <InputText id="coupon" className="w-full" value={couponValue}
                                               onChange={(e) => setCouponValue(e.target.value)}/>
                                    <Button icon="pi pi-check" className="p-button-success px-4"
                                            onClick={handleApplyClick}> Apply </Button>
                                </div>
                                <label htmlFor="coupon" className="block text-900 font-medium px-6">Discount
                                    code</label>
                                {invalidCoupon && transactionData.product.promo === false && (
                                    <Message severity="error" text="Invalid coupon"/>
                                )}
                            </FloatLabel>

                            <div>
                                <div className="py-2 mt-3 surface-border">
                                    <div className="flex justify-content-between align-items-center mb-3">
                                        <span className="text-900">Subtotal</span>
                                        <span className="text-900">
            {localCurrencyAmount
                ? `${localCurrencyCode} ${(transactionData.product.price * localCurrencyAmount).toFixed(2)}`
                : `${transactionData.product.currency_code} ${transactionData.product.price}`}
        </span>
                                    </div>
                                    <div className="flex justify-content-between align-items-center mb-3">
                                        <span className="text-900">Discount</span>
                                        <span className="text-900">
            {localCurrencyAmount
                ? `${localCurrencyCode} ${((transactionData.product.price - transactionData.product.price_with_discount) * localCurrencyAmount).toFixed(2)}`
                : `${transactionData.product.currency_code} ${(transactionData.product.price - transactionData.product.price_with_discount).toFixed(2)}`}
        </span>
                                    </div>
                                    <div className="flex justify-content-between align-items-center mb-3">
                                        <span className="text-900">Total</span>
                                        <span className="text-900 font-bold">
            {localCurrencyAmount
                ? `${localCurrencyCode} ${(transactionData.product.price_with_discount * localCurrencyAmount).toFixed(2)}`
                : `${transactionData.product.currency_code} ${transactionData.product.price_with_discount}`}
        </span>
                                    </div>
                                </div>

                               {transactionData.payment.length > 0 ? (
                                   <div
                                       className={`py-4 border-bottom-1 surface-border flex justify-content-between align-items-center ${hideSelector ? 'hidePayList' : ''}`}>
                                        <SelectButton
                                            value={selectedGateway}
                                            onChange={(e) => {
                                                if (e.value !== null) {
                                                    selectgateway(e.value);
                                                }
                                            }}
                                            itemTemplate={GatewaySelectTemplate}
                                            optionLabel="label"
                                            options={gatewayOptions}
                                        />
                                    </div>
                                ) : (
                                    <></>
                                )}


                                {showPaymentMethods && PaymentMethods.length > 0 ? (
                                    <div className={`py-4 border-bottom-1 surface-border flex justify-content-between align-items-center ${hideSelector ? 'hidePayList' : ''}`}>
                                        <SelectButton
                                            itemTemplate={PaymentSelectTemplate}
                                            value={selectedPaymentMethod}
                                            onChange={(e) => {
                                                if (e.value !== null) {
                                                    selectPayment(e.value);
                                                }
                                            }}
                                            options={PaymentMethods.map((method: any) => ({
                                                label: method.name,
                                                value: method,
                                            }))}
                                            optionLabel="label"
                                        />
                                    </div>
                                ) : (
                                    <>
                                    </>
                                    )}


                                {isApiError ? (
                                    <Message severity="error" text={apiErrorMessage} className="w-full"/>
                                ) : (
                                    <></>
                                )}

                                <Button label={placeOrderText} className="w-full" onClick={generateTransaction}
                                        disabled={disableButton}/>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    </div>
    )
}

export default PaymentPage;
